import colors from '../colors';
import * as React from 'react';
import styled from 'styled-components';
import * as PersonIcon from 'react-icons/lib/io/person';

const Wrapper = styled.div`
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: ${colors.mediumGray};
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${colors.darkGray};
    color: ${colors.darkGray};
    overflow: hidden;
`;

interface Props {}
interface State {}

export default class AnonymousAvatar extends React.Component<Props, State> {
    render() {
        return (
            <Wrapper>
                <PersonIcon size="100%" viewBox="5 1 30 30" />
            </Wrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/AnonymousAvatar.tsx